/**
 * Optimistic-UI kill switches (perceived-latency work).
 *
 * The battle client is server-authoritative: the authoritative WS echo is always the source of
 * truth. These flags gate *previews* — local, deterministic UI feedback shown the instant an action
 * is taken — which the authoritative echo then supersedes (or, on a server `error`, is rolled back).
 * Rollback is a proper error handler, not a fallback: it restores the UI to the authoritative state.
 *
 * Flip any flag to false to fully revert that behavior with no other code change.
 */

// Phase A: flip the turn indicator to "opponent's turn" (dim hand / disable affordances) the instant
// End Turn is pressed, instead of waiting a full round-trip for turn-ended/turn-played/game-update.
export const OPTIMISTIC_END_TURN_ENABLED = true;

// Phase C: render the player's OWN attack outcome (HP after / deaths) locally at animation hit-time,
// instead of waiting for the attack-complete round-trip. This reuses the exact spectator-proven
// applyAttackHitOutcomePreview path; the authoritative attack-complete still arrives and reconciles.
// Only perceptible on high-latency remote servers (localhost RTT is ~0). Flip to false to revert.
export const OPTIMISTIC_ATTACK_HIT_PREVIEW_ENABLED = true;
